<div class="container" [class.has-columns]="columns > 0" [class.horizontal]="horizontal">
  <div class="columns" [ngStyle]="style" #container>
    <label *ngFor="let option of options">
      <input type="radio" (change)="onChange(option.value)" [checked]="selected === option.value" [name]="name" [disabled]="disabled">
      <span>{{ option.title }}</span>
    </label>
  </div>
</div>

